<template>
  <BreadCrumb PageTitle="Éléments électriques des contrats" />
  <ListeContratElements />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ListeContratElements from "@/components/ContratElement/ListeContratElements.vue";

export default defineComponent({
  name: "ListeContratElementsPage",
  components: {
    BreadCrumb,
    ListeContratElements,
  },
});
</script>
